import {UnidadeState, UnidadeViewModel} from "@models/Unidade";
import React, {createContext, useEffect, useState} from "react";
import * as UnidadeService from "@services/UnidadeService";
import * as UsuarioService from "@services/UsuarioService";
import * as Autoescola from "@services/AutoescolaService";
import {Snackbar, SnackbarOrigin} from "@material-ui/core";
import MuiAlert, {Color} from "@material-ui/lab/Alert";

interface UnidadePageContextProps {
  model?: UnidadeState;
  buscarPorId(unidadeId: number);
  buscarPorAutoescolaId(autoescolaId: number);
  loadUsuarios(unidade: UnidadeViewModel, load);
  setModel(unidade: UnidadeState);
  modalSalvarAutoescola: boolean;
  setModalSalvarAutoescola(value: boolean);
  buscarPorAutoescolaIdFinanceiro: () => Promise<void>;
}
export interface AlertState extends SnackbarOrigin {
    open: boolean;
    type: Color;
    message: string;

}

function stringToBase64(str: string): string {
  return btoa(str);
}

export const UnidadePageContext = createContext<UnidadePageContextProps>({} as any);

export function UnidadePageProvider({ children }) {

    const [alert, setAlert] = useState<AlertState>({
        open: false,
        horizontal: "right",
        vertical: "top",
        type: "success",
        message: "Olá! ",
    });
    const { vertical, horizontal, open, type, message } = alert;
    const [model, setModel] = useState<UnidadeState>();
    const [modalSalvarAutoescola, setModalSalvarAutoescola] = React.useState(false);

    const buscarPorId = async (unidadeId: number) => {
        const unidade = await UnidadeService.GetById(unidadeId) as UnidadeViewModel;
        if (!unidade) {
            setAlert({
                ...alert,
                open: true,
                type: "error",
                message: "Unidade não encontrada"
            });
            setModel(undefined);
            return;
        }
        let unidadeLoad = await loadUsuarios(unidade);
        let nivelAplicativoAluno = await UnidadeService.GetNivelPorAutoescolaId(unidade.autoescolaId);

        let modelStart = {
            unidades: [unidadeLoad],
            nivelAplicativoAluno
        }
        setModel(modelStart);
        setTimeout(async () => {
            let rest = await UnidadeService.GetByAutoescolaId(unidade.autoescolaId);
            if (!rest.length) return;
            let todasUnidades = rest.filter(x => x.id !== unidade.id) as UnidadeViewModel[];
            if (!todasUnidades.length) return;
            setModel({
                ...modelStart, unidades: [unidadeLoad, ...todasUnidades]
            });

        }, 50);
    }
    const loadUsuarios = async (unidade: UnidadeViewModel, loadModel = false) => {
        if (!unidade.usuarios) {
            unidade.usuarios = await UsuarioService.BuscaPorUnidadeAtivos(unidade.id);
        }

        if (model) {
            let todasUnidades = model.unidades.filter(x => x.id !== unidade.id)
            setModel({
                ...model, unidades: [...todasUnidades, unidade]
            });
        }
        return unidade;
    }
    const buscarPorAutoescolaId = async (autoescolaId: number) => {
        let rest = await UnidadeService.GetByAutoescolaId(autoescolaId);
        if (!rest) {
            setAlert({
                ...alert,
                open: true,
                type: "error",
                message: "Unidades não encontradas"
            });
            setModel(undefined);
            return;
        }
        let unidade = rest[0]
        let unidadeLoad = await loadUsuarios(unidade as any);
        let nivelAplicativoAluno = await UnidadeService.GetNivelPorAutoescolaId(unidade.autoescolaId);

        rest[0] = unidadeLoad;
        let modelStart = {
            unidades: [...rest] as any,
            nivelAplicativoAluno
        }
        setModel(modelStart);

    }
    const buscarPorAutoescolaIdFinanceiro = async () => {
        try {
            if (!model?.unidades[0]) return
              const response = await Autoescola.GetAutoescolaFinanceiroById(
                model?.unidades[0].autoescolaId
              );
            if (!response) {
                setAlert({
                    ...alert,
                    open: true,
                    type: "error",
                    message: "Autoescola não encontrada"
                });
                return;
            }
            const codBase64 = stringToBase64(response.painelCliente.id.toString());
            const url = `https://financeiro.guiadocondutor.com.br/index/${codBase64}`;

            navigator.clipboard.writeText(url);
            window.open(url, "_blank");
            
        } catch (error) {
            setAlert({
                ...alert,
                open: true,
                type: "error",
                message: "Erro ao buscar autoescola"
            });
            console.log(error);
            
        }
    }
    const showToken = () => {
        let key = localStorage.getItem('@PainelInfor:token');
        if (!key) {
            setAlert({ ...alert, open: true, message: "Você não possui token", type: "error" });
            return;
        }
        navigator.clipboard.writeText(key.replaceAll('"',''))
        setAlert({ ...alert, open: true, message: "Token copiado para área de transferência", type: "success" });


    }
    useEffect(() => {
        function displayMessage(evt) {
            var message;
            if (evt.origin !== "https://app.pinkapp.com") return
            console.debug('message', evt.data);
            if (evt.data === 'show-token') {
                showToken()
                return;
            }
            buscarPorId(evt.data)

        }

        if (window.addEventListener) {
            // For standards-compliant web browsers
            window.addEventListener("message", displayMessage, true);
        }
        else {
            window["attachEvent"]("onmessage", displayMessage);
        }
        document.addEventListener('keydown', function (e) {
            if (e.key === "F2") {
                showToken();
                e.preventDefault();
                return false;
            }
        });
    }, [])

    return (
      <UnidadePageContext.Provider
        value={{
          model,
          buscarPorId,
          loadUsuarios,
          setModel,
          buscarPorAutoescolaId,
          modalSalvarAutoescola,
          setModalSalvarAutoescola,
          buscarPorAutoescolaIdFinanceiro
        }}
      >
        {children}
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          onClose={() => setAlert({ ...alert, open: false })}
          message="I love snacks"
          key={vertical + horizontal}
          autoHideDuration={4000}
        >
          <MuiAlert elevation={6} variant="filled" severity={type}>
            {message}
          </MuiAlert>
        </Snackbar>
      </UnidadePageContext.Provider>
    );

}
